import {Box, Stack, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";

export default function PrimaryRelativeFormControl({text, children}: any) {
    return (
        <Stack direction="row">
            {children}
            <Box sx={{
                height: 35.69,
                py: 1,
                px: 1.5,
                bgcolor: grey[100],
                borderTopRightRadius: 1,
                borderBottomRightRadius: 1,
                borderTop: `1px solid ${grey[400]}`,
                borderRight: `1px solid ${grey[400]}`,
                borderBottom: `1px solid ${grey[400]}`
            }}>
                <Typography fontSize={12}>{text}</Typography>
            </Box>
        </Stack>
    )
}